import * as React from 'react';
import { PureIconContainer } from './utils/IconContainer';
var Check = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Check_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 13
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.818 2.115a.5.5 0 0 1 .068.703l-9.5 11.5a.5.5 0 0 1-.74.036l-5.5-5.5a.5.5 0 0 1 .708-.708l5.11 5.112 9.15-11.076a.5.5 0 0 1 .704-.067Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Check_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
export default Check;